import { type TypedWrappedFieldProps } from "redux-form";

import type {
  ButtonSelectOption,
  ButtonSelectProps,
} from "@braintrust/braintrust-ui-components";
import { ButtonSelect } from "@braintrust/braintrust-ui-components";

type ButtonSelectFieldProps<
  TValue = string,
  TMultiple extends boolean = false,
  TOption extends ButtonSelectOption<TValue> = ButtonSelectOption<TValue>,
> = DistributiveOmit<
  ButtonSelectProps<TValue, TMultiple, TOption>,
  "value" | "onChange"
> &
  (TMultiple extends true
    ? TypedWrappedFieldProps<NoInfer<TValue[]>>
    : TypedWrappedFieldProps<NoInfer<TValue> | null>);

export const ButtonSelectField = <
  TValue = string,
  TMultiple extends boolean = false,
>({
  input,
  meta,
  ...props
}: ButtonSelectFieldProps<TValue, TMultiple>) => {
  return (
    <ButtonSelect {...props} {...input} error={meta.touched && meta.error} />
  );
};
